module.exports = __webpack_public_path__ + "static/media/bg.7bba9ce0.png";